import { AppState } from "../../reducers";
import { ProtectedState } from "./reducer";

export const protectedSelector = (state: AppState): ProtectedState => {
  return state.protected;
};
